import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';

export interface NumberedDocumentKey {
  reference?: string | null;
  number?: string | null;
}

export interface ProductionCardSearchItem {
  productionCard?: NumberedDocumentKey | null;
  fabricCode?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ProductionCardProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/production-card';

  public search(query: string, pageSize = 50): Observable<ApiResponse<PaginatedApiResponse<ProductionCardSearchItem>>> {
    const params = new HttpParams().set('pageNumber', 1).set('pageSize', pageSize);
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductionCardSearchItem>>>(
      `${this.baseUrl}/search/paginated`,
      { productionCardNumbers: query ? [query] : null },
      { params },
    );
  }
}
